<template>
  <div class="k-pagination-select-wrap">
    <global-dropdown
      id="rows-per-page-dropdown"
      :value="pageSize"
      :options="pageSizeOptions"
      :size="24"
      :min-width="68"
      trigger-class="k-pagination-select"
      panel-class="k-pagination-select-panel"
      :portal-z-index-max="969"
      append-to-body
      :disabled="isDisabled"
      @input="handleSelectChange"
    />
  </div>
</template>

<script>
import GlobalDropdown from '../GlobalDropdown.vue';

export default {
  name: 'PaginationOptions',
  components: {
    GlobalDropdown,
  },
  props: {
    totalItemsCount: {
      type: Number,
      required: true,
    },
    filteredItemsCount: {
      type: Number,
      required: true,
    },
    isServerSide: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      pageSize: 10,
    };
  },
  computed: {
    isDisabled() {
      return this.totalItemsCount === 0 || this.disabled;
    },
    isDisabled_10() {
      return this.filteredItemsCount < 6;
    },
    isDisabled_25() {
      return this.filteredItemsCount < 11;
    },
    isDisabled_50() {
      return this.filteredItemsCount < 26;
    },
    isDisabled_100() {
      return this.filteredItemsCount < 51;
    },
    isDisabled_250() {
      return this.filteredItemsCount < 101;
    },
    displayAllOption() {
      return !this.isServerSide && this.totalItemsCount < 1000;
    },
    pageSizeOptions() {
      const options = [
        { id: 'page-size-5', value: 5, label: '5' },
        {
          id: 'page-size-10',
          value: 10,
          label: '10',
          disabled: this.isDisabled_10,
        },
        {
          id: 'page-size-25',
          value: 25,
          label: '25',
          disabled: this.isDisabled_25,
        },
        {
          id: 'page-size-50',
          value: 50,
          label: '50',
          disabled: this.isDisabled_50,
        },
        {
          id: 'page-size-100',
          value: 100,
          label: '100',
          disabled: this.isDisabled_100,
        },
        {
          id: 'page-size-250',
          value: 250,
          label: '250',
          disabled: this.isDisabled_250,
        },
      ];
      if (this.displayAllOption) {
        options.push({ id: 'page-size-all', value: 'all', label: 'All' });
      }
      return options;
    },
  },
  methods: {
    handleSelectChange(raw) {
      const pageSize = raw === 'all' ? 'all' : parseInt(raw, 10);
      if (pageSize === this.pageSize) return;
      this.pageSize = pageSize;
      this.$emit('set-page-size', pageSize);
    },
    /**
     * Called externally by PaginationControls
     * @param {Number|String} pageSize
     */
    setPageSizeOption(pageSize) {
      this.pageSize = pageSize;
    },
  },
};
</script>

<style lang="scss">
.k-pagination-select-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  z-index: 20;
  margin-left: 8px;
}

.k-pagination-select {
  width: 68px;
}

html.dark .k-pagination-select .sb-global-dropdown__chevron {
  color: #e5e7eb;
}
@media (prefers-color-scheme: dark) {
  html:not(.light):not(.dark)
    .k-pagination-select
    .sb-global-dropdown__chevron {
    color: #e5e7eb;
  }
}
</style>
